<template>
  <div>
    <div style="display: flex; flex-direction: column; margin-top: 20px">
      <v-form>
        <div style="display: flex; padding-block: 10px; padding-inline: 20px">
          <div
            style="display: flex; flex-direction: column; align-items: center"
          >
            <v-layout>
              <v-flex>
                <img
                  :src="storeProfileImage"
                  :style="{
                    width: height * 1.3 + 'px',
                    height: 220.17,
                    border: '1px solid gray',
                  }"
                  alt="Cropped Image"
                  v-if="storeProfileImage && storeProfileImage != null"
                />
                <v-card
                  :height="220.17 + 'px'"
                  :width="height * 1.3 + 'px'"
                  color="grey"
                  class="text-xs-center pt-3"
                  v-else
                >
                  No image</v-card
                >
              </v-flex>
            </v-layout>
            <div style="margin-bottom: 20px"></div>
            <v-layout>
              <v-flex>
                <v-btn @click="$refs.ProfileInput.click()">Choose Files</v-btn>
                <input
                  style="display: none"
                  type="file"
                  @change="onProfileImageSelected"
                  ref="ProfileInput"
                  accept="image/*"
                />
              </v-flex>
            </v-layout>
          </div>
          <div style="margin-right: 50px"></div>
          <v-layout wrap style="padding-right: 10px; padding-bottom: 30px">
            <v-flex md12 xs12>
              <v-layout>
                <v-flex>
                  <p class="info-header">Store Type Name (Thai)</p>
                  <v-text-field
                    solo
                    required
                    v-model="storeNameTH"
                    :rules="storeNameRules"
                  >
                  </v-text-field>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex md12 xs12>
              <v-layout>
                <v-flex>
                  <p class="info-header">Store Type Name (English)</p>
                  <v-text-field
                    solo
                    required
                    v-model="storeNameEN"
                    :rules="storeNameRules"
                  >
                  </v-text-field>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </div>
        <!-- <v-dialog v-model="collect_store_images_dialog" max-width="65vw">
          <v-card>
            <imageCropper
              :aspectRatio="480 / 320"
              :imageName="selectedFile.store_img_name"
              :imgSrc="storeImageTemp"
              :height="300"
              @close="collect_store_images_dialog = false"
              @setImageName="selectedFile.store_img_name = $event"
              @getCroped="getCollectCropped($event)"
              v-if="storeImageTemp != ''"
            ></imageCropper>
          </v-card>
        </v-dialog> -->
        <v-dialog v-model="store_images_dialog" max-width="65vw">
          <v-card>
            <imageCropper
              :aspectRatio="480 / 320"
              :imageName="selectedFile.store_img_name"
              :imgSrc="storeImageTemp"
              :height="300"
              @close="store_images_dialog = false"
              @setImageName="selectedFile.store_img_name = $event"
              @getCroped="getProfileCropped($event)"
              v-if="storeImageTemp != ''"
            ></imageCropper>
          </v-card>
        </v-dialog>
      </v-form>
    </div>

    <v-divider style="margin-top: 20px"></v-divider>
    <div
      style="
        display: flex;
        justify-content: flex-end;
        padding-block: 10px;
        padding-inline: 20px;
        margin-top: 20px;
      "
    >
      <v-btn @click="updateDineInStore" color="#fddf00"
        ><strong> Update </strong>
      </v-btn>
    </div>
    <v-dialog v-model="error_dialog" persistent max-width="500">
      <v-card>
        <div
          style="
            background-color: #fddf00;
            height: 60px;
            display: flex;
            align-items: center;
            padding-left: 20px;
          "
        >
          <v-icon large style="margin-right: 10px" color="black"
            >warning</v-icon
          >
          <div style="font-size: 1.8rem">Warning</div>
        </div>
        <v-card-title class="headline" primary-title>{{
          error_text
        }}</v-card-title>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" flat @click="error_dialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="failed_dialog" max-width="350">
      <v-card style="border-radius: 20px">
        <div
          style="
            display: flex;
            flex-direction: column;
            align-items: center;
            padding-block: 30px;
          "
        >
          <v-icon
            x-large
            style="margin-bottom: 10px; font-size: 70px"
            color="red"
            >close</v-icon
          >
          <div style="font-size: 1.8rem">Update Failed</div>
        </div>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" flat @click="failed_dialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
  
<script>
import imageCropper from "@/components/Plugins/imageCropper.vue";
import imageUploader from "@/components/back-office/StoreManagement/ImageUploader.vue";
export default {
  props: ["store_type_data"],
  data: () => ({
    change: 0,
    dialog: true,
    storeNameTH: "",
    storeNameEN: "",
    error_dialog: false,
    store_images_dialog: false,
    failed_dialog: false,
    change_image: 0,
    height: 300,
    storeImageTemp: "",
    error_text: "",
    selectedFile: {
      store_img: "",
      store_img_name: "",
    },
    storeProfileImage: "",
    storeStatus: false,
    storeNameRules: [
      (v) => {
        if (v === "") {
          return "Store type name is required";
        } else {
          return true;
        }
      },
    ],
  }),
  components: { imageCropper, imageUploader },
  watch: {
    store_type_data: function () {
      this.storeNameTH = this.store_type_data.store_type_name_th;
      this.storeNameEN = this.store_type_data.store_type_name_en;
      this.storeProfileImage = this.store_type_data.store_type_image;
    },
  },
  methods: {
    getProfileCropped(image_value) {
      this.storeProfileImage = image_value;
      this.selectedFile = { store_img: "", store_img_name: "" };
      this.change_image = 1;
      this.storeImageTemp = "";
    },
    openDeleteStoreImageIndex(index) {
      this.deleteImgDialog = true;
      this.deleteImageIndex = index;
    },
    onProfileImageSelected(event) {
      this.storeImageTemp = "";
      let file = event.target.files[0];
      this.selectedFile.store_img_name = file.name;
      let reader = new FileReader();
      reader.addEventListener("load", () => {
        this.storeImageTemp = reader.result;
        this.store_images_dialog = true;
      });
      reader.readAsDataURL(file);
      event.target.value = "";
    },
    async updateDineInStore() {
      if (this.storeProfileImage === "") {
        this.error_text = "Please upload store type image.";
        this.error_dialog = true;
        return;
      }
      var payload = {
        data: {
          store_type_id: this.store_type_data.store_type_id,
          store_type_name_th: this.storeNameTH,
          store_type_name_en: this.storeNameEN,
          store_type_status: 1,
          store_type_profile: this.storeProfileImage,
        },
      };
      var res = await this.$store.dispatch(
        "fetchDineIn/updateDineInStoreType",
        payload
      );
      if (res === false) {
        this.failed_dialog = true;
      } else {
        this.$emit("closeEditDialog");
        this.resetData();
      }
    },
    resetData() {
      this.storeNameTH = "";
      this.storeNameEN = "";
      this.storeImageTemp = "";
      this.error_text = "";
      this.storeProfileImage = "";
      this.storeStatus = false;
    },
  },
};
</script>
<style scoped>
.info-header {
  margin-right: 10px;
  font-size: 18px;
  font-weight: 600;
}
</style>